import * as React from "react"
import { AccordionSeeker } from "@ui-seeker/core";
import { AppTableSeeker } from "@components"

import { retailerColumn, graphColumn, totalColumn } from "./columns";
import { useSignal } from "@preact/signals-react";
import { useAdminProductReviewSubmits } from "../@hooks";


export default function AdminProductReviewHeaderTable() {
	const { adminProductReviewHeaderSummary } = useAdminProductReviewSubmits()
	const isOpen = useSignal(false)

	if (!adminProductReviewHeaderSummary?.length) return <></>

	return <AccordionSeeker
		title="Mapping  Summary"
		expanded={isOpen.value}
		onChange={() => isOpen.value = !isOpen.value}
		sx={{ mb: 2 }}
	>
		<AppTableSeeker
			data={adminProductReviewHeaderSummary}
			columns={[
				...retailerColumn(),
				totalColumn('totalProducts', 'Total Products'),
				totalColumn('prevTotalProducts', 'Previous Total Products'),
				graphColumn('mappedShare', 'Mapped Product'),
				graphColumn('matchedShare', 'Matched Share'),
				graphColumn('validatedShare', 'Validated Share')
			]}
		/>
	</AccordionSeeker>
}